export default "__VITE_ASSET__osfUbBmM__"